export default {
  image: 'A2_4.png',
  pdf: '220922_WA-HWF_004_A2_4_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-HWF-004',
    technicalValues: {
      soundReductionIndex: {
        output: '51,0',
        value: 51
      },
      heatTransferCoefficient: {
        output: '0,20',
        value: 0.2
      },
      fireBehavior: {
        output: 'normalentflammbar (B2)',
        value: 'B2'
      },
      fireResistanceOuter: {
        output: 'F 60-B',
        value: 'F-60-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Holzweichfaser l Aufbau 4',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '60 mm Sto-Weichfaserplatte M050',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'wmo50-60'
        },
        {
          output: 'ohne',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: null
        },
        {
          output: '≥ 60/160',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-160'
        },
        {
          output: '160 mm Zellulose',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cicf-160'
        },
        {
          output: '15 mm OSB-Platte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ib-15'
        },
        {
          output: '9,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'im-9'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '251,5',
        value: 251.5
      }
    }
  }
}
